var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoyaltyPoints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.2002 12.848C1.2002 19.2338 6.37736 24.411 12.7632 24.411C19.1491 24.411 24.3263 19.2338 24.3263 12.848C24.3263 6.46156 19.1491 1.28491 12.7632 1.28491C6.37736 1.28491 1.2002 6.46156 1.2002 12.848Z",
    fill: "url(#paint0_linear_2749_3779)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5936 21.8412C17.5605 21.8412 21.5871 17.8146 21.5871 12.8477C21.5871 7.88076 17.5605 3.85425 12.5936 3.85425C7.62661 3.85425 3.6001 7.88076 3.6001 12.8477C3.6001 17.8146 7.62661 21.8412 12.5936 21.8412ZM13.9429 9.25034C14.2374 9.64251 14.4485 10.101 14.5497 10.5994H16.191V11.9484H14.5497C14.2371 13.4878 12.8762 14.6464 11.2446 14.6464H11.0743L14.4195 17.9917L13.4657 18.9456L8.99619 14.4762V13.2974H11.2446C12.1256 13.2974 12.8752 12.7343 13.153 11.9484H8.99619V10.5994H13.153C12.8752 9.81343 12.1256 9.25034 11.2446 9.25034H8.99619V7.90131H16.191V9.25034H13.9429Z",
    fill: "#F5A50B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2749_3779",
    x1: 12.7632,
    y1: 1.28491,
    x2: 12.7632,
    y2: 24.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5437E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED1C24"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoyaltyPoints);
export default __webpack_public_path__ + "static/media/loyaltyPoints.a2eff1f9578c4076cab34b3678d1500f.svg";
export { ForwardRef as ReactComponent };